"use client";

import { c as _c } from "react/compiler-runtime";
import TimePicker from "@/components/common/TimePicker";
import TooltipIconButton from "@/components/common/TooltipIconButton";
import CommonCalendar from "@/components/utils/calendar/CommonCalendar";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useCallback, useEffect, useState } from "react";
interface DecisionsFirstProps {
  readonly firstDecisionTime: number;
  readonly setFirstDecisionTime: (time: number) => void;
  readonly minTimestamp: number | null; // Minimum allowed timestamp (typically votingStartDate)
}
export default function DecisionsFirst(t0) {
  const $ = _c(49);
  const {
    firstDecisionTime,
    setFirstDecisionTime,
    minTimestamp
  } = t0;
  const [selectedTimestamp, setSelectedTimestamp] = useState(firstDecisionTime);
  const [minTimeObj, setMinTimeObj] = useState(null);
  let t1;
  let t2;
  if ($[0] !== firstDecisionTime) {
    t1 = () => {
      setSelectedTimestamp(firstDecisionTime);
    };
    t2 = [firstDecisionTime];
    $[0] = firstDecisionTime;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== firstDecisionTime || $[4] !== minTimestamp || $[5] !== setFirstDecisionTime) {
    t3 = () => {
      if (minTimestamp) {
        const minDate = new Date(minTimestamp);
        setMinTimeObj({
          hours: minDate.getHours(),
          minutes: minDate.getMinutes()
        });
        const isInitialOrChange = !firstDecisionTime || firstDecisionTime < minTimestamp || firstDecisionTime === minTimestamp;
        if (isInitialOrChange) {
          const defaultDate = new Date(minTimestamp);
          defaultDate.setHours(23, 59, 0, 0);
          setSelectedTimestamp(defaultDate.getTime());
          setFirstDecisionTime(defaultDate.getTime());
        }
      } else {
        setMinTimeObj(null);
      }
    };
    t4 = [minTimestamp, setFirstDecisionTime, firstDecisionTime];
    $[3] = firstDecisionTime;
    $[4] = minTimestamp;
    $[5] = setFirstDecisionTime;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== selectedTimestamp) {
    t5 = () => new Date(selectedTimestamp).getHours();
    $[8] = selectedTimestamp;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const getHours = t5;
  let t6;
  if ($[10] !== selectedTimestamp) {
    t6 = () => new Date(selectedTimestamp).getMinutes();
    $[10] = selectedTimestamp;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const getMinutes = t6;
  let t7;
  if ($[12] !== selectedTimestamp || $[13] !== setFirstDecisionTime) {
    t7 = (hours, minutes) => {
      const date = new Date(selectedTimestamp);
      date.setHours(hours, minutes, 0, 0);
      const newTimestamp = date.getTime();
      setSelectedTimestamp(newTimestamp);
      setFirstDecisionTime(newTimestamp);
    };
    $[12] = selectedTimestamp;
    $[13] = setFirstDecisionTime;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const onTimeChange = t7;
  let t8;
  if ($[15] !== minTimeObj || $[16] !== minTimestamp || $[17] !== selectedTimestamp || $[18] !== setFirstDecisionTime) {
    t8 = timestamp => {
      const currentDate = new Date(selectedTimestamp);
      const newDate = new Date(timestamp);
      const currentHours = currentDate.getHours();
      const currentMinutes = currentDate.getMinutes();
      const isMinTimestampDay = minTimestamp && newDate.toDateString() === new Date(minTimestamp).toDateString();
      if (isMinTimestampDay && minTimeObj) {
        if (currentHours < minTimeObj.hours || currentHours === minTimeObj.hours && currentMinutes < minTimeObj.minutes) {
          const bufferHours = minTimeObj.hours;
          const bufferMinutes = minTimeObj.minutes + 30;
          const adjustedHours = bufferMinutes >= 60 ? bufferHours + 1 : bufferHours;
          const adjustedMinutes = bufferMinutes >= 60 ? bufferMinutes - 60 : bufferMinutes;
          newDate.setHours(adjustedHours, adjustedMinutes, 0, 0);
        } else {
          newDate.setHours(currentHours, currentMinutes, 0, 0);
        }
      } else {
        newDate.setHours(currentHours, currentMinutes, 0, 0);
      }
      const newTimestamp_0 = newDate.getTime();
      setSelectedTimestamp(newTimestamp_0);
      setFirstDecisionTime(newTimestamp_0);
    };
    $[15] = minTimeObj;
    $[16] = minTimestamp;
    $[17] = selectedTimestamp;
    $[18] = setFirstDecisionTime;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const handleDateSelection = t8;
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-mb-3"><p className="tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-100">First Winners Announcement</p><TooltipIconButton icon={faInfoCircle} tooltipText="This is when you'll announce the first set of winners for your wave. It must occur after voting begins. This is when creators will find out if they've won and their work will be showcased." tooltipPosition="right" tooltipWidth="tw-w-72" /></div>;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="tw-mb-2 tw-text-sm tw-font-medium tw-text-iron-300">Select Date:</p>;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== selectedTimestamp) {
    t11 = new Date(selectedTimestamp).getMonth();
    $[22] = selectedTimestamp;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== selectedTimestamp) {
    t12 = new Date(selectedTimestamp).getFullYear();
    $[24] = selectedTimestamp;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== handleDateSelection || $[27] !== minTimestamp || $[28] !== selectedTimestamp || $[29] !== t11 || $[30] !== t12) {
    t13 = <div className="tw-w-full">{t10}<CommonCalendar initialMonth={t11} initialYear={t12} selectedTimestamp={selectedTimestamp} minTimestamp={minTimestamp} maxTimestamp={null} setSelectedTimestamp={handleDateSelection} /></div>;
    $[26] = handleDateSelection;
    $[27] = minTimestamp;
    $[28] = selectedTimestamp;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <p className="tw-mb-2 tw-text-sm tw-font-medium tw-text-iron-300">Select Time:</p>;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== getHours) {
    t15 = getHours();
    $[33] = getHours;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== getMinutes) {
    t16 = getMinutes();
    $[35] = getMinutes;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== minTimeObj || $[38] !== minTimestamp || $[39] !== selectedTimestamp) {
    t17 = minTimestamp && new Date(selectedTimestamp).toDateString() === new Date(minTimestamp).toDateString() ? minTimeObj : null;
    $[37] = minTimeObj;
    $[38] = minTimestamp;
    $[39] = selectedTimestamp;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== onTimeChange || $[42] !== t15 || $[43] !== t16 || $[44] !== t17) {
    t18 = <div className="tw-w-full">{t14}<TimePicker hours={t15} minutes={t16} onTimeChange={onTimeChange} minTime={t17} /></div>;
    $[41] = onTimeChange;
    $[42] = t15;
    $[43] = t16;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t13 || $[47] !== t18) {
    t19 = <div className="tw-col-span-2">{t9}<div className="tw-grid tw-grid-cols-1 tw-gap-y-8 tw-gap-x-10 md:tw-grid-cols-2">{t13}{t18}</div></div>;
    $[46] = t13;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  return t19;
}